import initialState from './initialState';
import {
  FETCH_ACCOUNTS_FOR_ACCOUNT_MAP_FAILURE,
  FETCH_ACCOUNTS_FOR_ACCOUNT_MAP_SUCCESS,
  FETCHING_DATA_FOR_ACCOUNTS_MAP_MODAL,
  FETCHING_DATA_FOR_ACCOUNTS_MAP_MODAL_FINISHED,
} from './types';

export default function AccountMapReducer(state = initialState, action = {}) {
  switch (action.type) {
    case FETCH_ACCOUNTS_FOR_ACCOUNT_MAP_SUCCESS:
      return {
        ...state,
        accounts: action.accounts,
      };
    case FETCH_ACCOUNTS_FOR_ACCOUNT_MAP_FAILURE:
      return {
        ...state,
        accounts: initialState.accounts,
      };
    case FETCHING_DATA_FOR_ACCOUNTS_MAP_MODAL:
      return {
        ...state,
        isFetchingInitialDataForAddAndEditModal: true,
      };
    case FETCHING_DATA_FOR_ACCOUNTS_MAP_MODAL_FINISHED:
      return {
        ...state,
        isFetchingInitialDataForAddAndEditModal: false,
      };
    default:
      return state;
  }
}
